module.exports = __webpack_public_path__ + "img/candle-selected.21a82194.svg";